import React from 'react';
import BaseHotStampingChooser from 'components/quote_builder_widget/shared/BaseHotStampingChooser';
import styles from './_style.module.scss';

const HotStampingChooser = ({ widgetIdentifier, cartonMaterialUserPriceId, drawingId, unit }) => {
  return (
    <BaseHotStampingChooser
      widgetIdentifier={widgetIdentifier}
      cartonMaterialUserPriceId={cartonMaterialUserPriceId}
      drawingId={drawingId}
      unit={unit}
      styles={styles}
      selectClassName={`${styles.input} ${styles.select}`}
      lengthInputClassName={`${styles.input} ${styles.inputWithSuffix}`}
    />
  );
};

export default HotStampingChooser;
